import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { useEffect as f } from "react";
import { h as p } from "./index-Dj1VNACs.mjs";
import { A as u } from "./index-isgVnOkQ.mjs";
import { f as g } from "./index-LyFokDcn.mjs";
import { m as h } from "./tss-DN0acMKN.mjs";
import { M as s, d as r } from "./constants-CnFYFetN.mjs";
const l = "7128ba14", d = "https://staticfe.bamboohr.com/assets/icons", x = `sprite_${l}.svg`, E = `${d}/${x}`, y = `icon-manifest_${l}.json`, A = `${d}/${y}`, c = "fabric-sprite";
let a = !1;
const b = () => {
  !document.getElementById(c) && !a && (a = !0, u.get(E).then((e) => {
    const t = e.data, o = document.createRange().createContextualFragment(t), n = o.querySelector("svg");
    if (n)
      n.id = c, n.style.display = "none";
    else
      throw new Error("Unable to add Fabric sprite to page.");
    document.body.appendChild(o), a = !1;
  }).catch((e) => {
    a = !1, console.error(e);
  }));
}, I = h()(({ palette: e, mode: t }, { brand: o }) => {
  const n = o ? e.primary.main : void 0;
  return g.ifFeature(
    "encore",
    // mark legacy icons with construction tape so it's obvious they should not be used
    {
      root: window.ENV === "dev" || window.ENV === "stage" ? {
        background: "repeating-linear-gradient(45deg, #222222, #222222 4px, #f0d232 4px, #f0d232 8px)",
        "& *": {
          display: "none"
        }
      } : {
        fill: t === s.Dye ? r.main : n,
        outline: t === s.Dye ? `1px solid ${r.main}` : void 0
      }
    },
    {
      root: {
        fill: t === s.Dye ? r.main : n,
        outline: t === s.Dye ? `1px solid ${r.main}` : void 0
      }
    }
  );
});
function $(e) {
  const t = /-(\d+)x(\d+)$/, [o, n, m] = t.exec(e) || [!1];
  return o || p.handleError(`${e} is an invalid icon name. Icon names must end with dimensions. Example: "-1x1".`), {
    width: Number(n),
    height: Number(m)
  };
}
const C = ({ name: e, brand: t }) => {
  f(() => b(), []);
  const { classes: o } = I({ brand: t });
  return /* @__PURE__ */ i.jsx(
    "svg",
    {
      "aria-hidden": !0,
      className: o.root,
      "data-fabric-component": "Icon",
      focusable: !1,
      pointerEvents: "none",
      ...$(e),
      children: /* @__PURE__ */ i.jsx("use", { xlinkHref: `#${e}` })
    }
  );
};
export {
  C as I,
  A as a
};
//# sourceMappingURL=icon-CvGUqXUP.mjs.map
